import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { DetailedCustomer } from '../../models/customer.model';
import { SHOP_LISTING_QUERY_PARAMS_RESET } from '../../utils/shop-query-params';

@Component({
  selector: 'app-logo-header',
  templateUrl: './logo-header.component.html',
  styleUrls: ['./logo-header.component.scss'],
  imports: [CommonModule, MatIconModule],
})
export class LogoHeaderComponent {
  @Input() menuOpen: boolean = false;
  @Output() menuOpenChange = new EventEmitter<boolean>();
  @Input() customer: DetailedCustomer;
  constructor(private router: Router) {}

  navigateToShop(): void {
    if (!this.customer) return;
    this.router.navigate(['/shop'], {
      queryParams: SHOP_LISTING_QUERY_PARAMS_RESET,
      queryParamsHandling: 'merge',
    });
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
    this.menuOpenChange.emit(this.menuOpen);
  }
}
